import React from "react";

const JoinEventAction = () => {
  return (
    <div className="px-4 pb-8 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-gradient-to-r from-blue-50 to-purple-100 border-l-4 border-indigo-500 text-indigo-900 p-6 sm:p-8 mt-12 rounded-xl shadow-md">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-indigo-800">
          🌍 Ready for the Journey of a Lifetime?
        </h2>

        <p className="mt-3 text-base sm:text-lg leading-relaxed">
          Discover breathtaking destinations, connect with incredible people,
          and create stories worth telling.
        </p>
        <p className="mt-4 text-sm sm:text-base text-red-700">
          Spots are filling fast! Don’t miss your chance to be part of something
          truly special.
        </p>
        {/* <div className="mt-6">
          <a
            href="/book-now"
            className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white text-sm sm:text-base font-semibold py-3 px-6 rounded-md shadow transition duration-200"
          >
            🚀 Join Now
          </a>
        </div> */}
        <p className="mt-5 text-sm text-indigo-600">
          Need help or have questions?{" "}
          <a
            href="https://wa.me/message/XNOUEIARKVJIO1"
            target="_blank"
            rel="noopener noreferrer"
            className="underline font-medium"
          >
            Reach out to us
          </a>{" "}
          — we’re happy to help!
        </p>
      </div>
    </div>
  );
};

export default JoinEventAction;
